import { skyroverTheme } from '@/theme/skyroverTheme';
import { CssBaseline, ThemeProvider } from '@mui/material';
import type { ReactNode } from 'react';

import '@/styles/blockly-overrides.css';
import '@/styles/toolbox-category-icons.css';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={skyroverTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
